<template>
  <div class="notificationView">
    <el-dialog
      title="公告详情"
      :visible.sync="visible"
      width="750px"
      :before-close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="ql-container ql-snow content">
        <div class="content_title">{{ form.title }}</div>
        <div class="content_time">发布时间：{{ form.publishTime }}</div>
        <div class="ql-editor content_html" v-html="form.contentHtml"></div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  export default {
    name: 'notificationView',
    data() {
      return {
        visible: false,
        id: null,
        form: {
          title: '',
          publishTime: '',
          contentHtml: ''
        }
      }
    },
    methods: {
      async getDetail () {
        const res = await req.post('/announcement/employee/read', { announcementId: this.id })
        if (res.code === 200) {
          this.form.title = res.data.title
          this.form.publishTime = res.data.publishTime
          this.form.contentHtml = res.data.contentHtml

          this.$store.dispatch('getNoticeNum')
        }
      },
      open(id) {
        this.id = id
        this.visible = true
        this.getDetail()
      },
      close() {
        this.visible = false
        this.form = {
          title: '',
          publishTime: '',
          contentHtml: ''
        }
        this.$emit('update')
      }
    }
  }
</script>

<style lang="less" scoped>
  .notificationView /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .notificationView /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .notificationView /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .notificationView /deep/ .el-dialog__body {
    padding: 0px;
  }

  .notificationView /deep/ .el-dialog__footer {
    padding: 0px;
  }

  .content {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    max-height: 460px;
    border: none;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .content_title {
    line-height: 24px;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
  }

  .content_time {
    margin: 6px 0 0 0;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .content_html {
    margin: 10px 0 0 0;
    padding: 0;
    width: 100%;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    border-top: 1px solid #EBEAEE;
  }
</style>